module.exports = __webpack_public_path__ + "img/preview-without-border.2cb66622.svg";